import { render } from "./SocialButtons.vue?vue&type=template&id=756d8201&scoped=true"
import script from "./SocialButtons.vue?vue&type=script&lang=js"
export * from "./SocialButtons.vue?vue&type=script&lang=js"

import "./SocialButtons.vue?vue&type=style&index=0&id=756d8201&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756d8201"]])

export default __exports__